var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('h3', [_vm._v("Typing Assistance:")]), _c('ul', {
    attrs: {
      "role": "menu"
    }
  }, [_c('li', {
    attrs: {
      "role": "menuitem"
    }
  }, [_c('button', {
    staticClass: "accessibility-text-helper-dropdown-button",
    attrs: {
      "id": "view-total-text",
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": _vm.handleOnClick,
      "keypress": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleOnClick($event);
      }
    }
  }, [_vm._v("\n        Text to type\n      ")])]), _c('li', {
    attrs: {
      "role": "menuitem"
    }
  }, [_c('button', {
    staticClass: "accessibility-text-helper-dropdown-button",
    attrs: {
      "id": "view-completed-text",
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": _vm.handleOnClick,
      "keypress": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleOnClick($event);
      }
    }
  }, [_vm._v("\n        Completed text\n      ")])]), _c('li', {
    attrs: {
      "role": "menuitem"
    }
  }, [_c('button', {
    staticClass: "accessibility-text-helper-dropdown-button",
    attrs: {
      "id": "view-incomplete-text",
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": _vm.handleOnClick,
      "keypress": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleOnClick($event);
      }
    }
  }, [_vm._v("\n        Remaining text to type\n      ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }